module.exports = __webpack_public_path__ + "static/media/S1N8-1.13f8b8f2.svg";